import { TEILNEHMENDE_TABELLE, type LoeschErgebnis } from '@/core/api/testdaten'

export type Ergebnis = { ton: 'success' | 'error'; text: string }

export type Zustand =
  | { phase: 'bereit'; ergebnis: Ergebnis | null }
  | { phase: 'zaehlt' }
  | { phase: 'bestaetigen'; zaehlung: LoeschErgebnis }
  | { phase: 'loescht'; zaehlung: LoeschErgebnis }
  | { phase: 'legtAn'; fortschritt: string }

export type Ereignis =
  | { typ: 'zaehlen' }
  | { typ: 'gezaehlt'; zaehlung: LoeschErgebnis }
  | { typ: 'abbrechen' }
  | { typ: 'loeschen' }
  | { typ: 'geloescht'; ergebnis: LoeschErgebnis }
  | { typ: 'anlegen' }
  | { typ: 'fortschritt'; text: string }
  | { typ: 'angelegt'; anzahl: number }
  | { typ: 'fehler'; text: string }

export const ANFANG: Zustand = { phase: 'bereit', ergebnis: null }

export function anzahlTeilnehmende(ergebnis: LoeschErgebnis): number {
  return ergebnis.geloescht[TEILNEHMENDE_TABELLE] ?? 0
}

export function laeuft(zustand: Zustand): boolean {
  return zustand.phase === 'zaehlt' || zustand.phase === 'loescht' || zustand.phase === 'legtAn'
}

export function weiter(zustand: Zustand, ereignis: Ereignis): Zustand {
  switch (ereignis.typ) {
    case 'zaehlen':
      return zustand.phase === 'bereit' ? { phase: 'zaehlt' } : zustand
    case 'gezaehlt':
      return zustand.phase === 'zaehlt' ? { phase: 'bestaetigen', zaehlung: ereignis.zaehlung } : zustand
    case 'abbrechen':
      return zustand.phase === 'bestaetigen' ? ANFANG : zustand
    case 'loeschen':
      return zustand.phase === 'bestaetigen' ? { phase: 'loescht', zaehlung: zustand.zaehlung } : zustand
    case 'geloescht':
      if (zustand.phase !== 'loescht') return zustand
      return {
        phase: 'bereit',
        ergebnis: ereignis.ergebnis.ausgefuehrt
          ? { ton: 'success', text: `${anzahlTeilnehmende(ereignis.ergebnis)} Teilnehmende gelöscht` }
          : { ton: 'error', text: "Der Server hat nur gezählt und nichts gelöscht." },
      }
    case 'anlegen':
      return zustand.phase === 'bereit' ? { phase: 'legtAn', fortschritt: "Wird vorbereitet …" } : zustand
    case 'fortschritt':
      return zustand.phase === 'legtAn' ? { phase: 'legtAn', fortschritt: ereignis.text } : zustand
    case 'angelegt':
      return zustand.phase === 'legtAn'
        ? { phase: 'bereit', ergebnis: { ton: 'success', text: `${ereignis.anzahl} Teilnehmende angelegt` } }
        : zustand
    case 'fehler':
      return laeuft(zustand) ? { phase: 'bereit', ergebnis: { ton: 'error', text: ereignis.text } } : zustand
  }
}

export function zaehlungText(zaehlung: LoeschErgebnis): { titel: string; tabellen: string } {
  const tabellen = Object.entries(zaehlung.geloescht)
    .filter(([, n]) => n > 0)
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([tabelle, n]) => `${tabelle} ${n}`)
    .join(', ')
  return {
    titel: `${anzahlTeilnehmende(zaehlung)} Teilnehmende und ${zaehlung.dateien} Dateien werden endgültig gelöscht.`,
    tabellen: tabellen === '' ? "Keine Zeilen zu löschen." : `Zeilen: ${tabellen}.`,
  }
}
